import { render, staticRenderFns } from "./ShowDataSourcesList.vue?vue&type=template&id=d4952698&scoped=true"
import script from "./ShowDataSourcesList.vue?vue&type=script&lang=js"
export * from "./ShowDataSourcesList.vue?vue&type=script&lang=js"
import style0 from "./ShowDataSourcesList.vue?vue&type=style&index=0&id=d4952698&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4952698",
  null
  
)

export default component.exports